<template>
  <span class="bg-[#2A4493] text-white px-4 py-1 rounded-full text-sm font-semibold tracking-wide">
    {{ category }}
  </span>
</template>

<script setup>
defineProps({
    category: {
        type: String,
        required: true
    }
})
</script>
